'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactivationModalContainer = exports.mapDispatchToProps = exports.mapStateToProps = exports.modalConfig = undefined;

var _reactRedux = require('react-redux');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _modals = require('redux/modules/modals');

var _ReactivationModal = require('features/Reactivation/ReactivationModal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modalConfig = exports.modalConfig = {
  lightClose: true
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps() {
  return {};
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  onCtaClick: _modals.hideModal
};

var ReactivationModalContainer = exports.ReactivationModalContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _Modal2.default)(modalConfig)(_ReactivationModal.ReactivationModal));